import React, {useCallback, useEffect, useState} from 'react';
import {
  Container,
  ModalBody,
  ModalContent,
  ProductCategoryItem,
  ProductCategoryInfos,
  ProductMask,
  ProductCategoryImage,
  ProductTypeName,
  CloseButton,
  CloseButtonIcon,
  ModalInfos,
  ModalTitle,
  ModalSubtitle,
} from './styles';


import {api} from '../../../services/api';
import {ProductDTO} from '../../../dtos/ProductDTO';
import { StationDTO } from '../../../dtos/StationDTO';


interface Props {
  showModal: boolean;
  availableTypes?: {
    loja_id: string;
    tipo_produto: string;
  }[];
  onDismiss: () => void;
  onConfirm: (products: ProductDTO[], loja: StationDTO, tipo: string) => void;
}

interface IProductTypes {
  nome: string;
  codigo: string;
  ordem: number;
  image_url: string;
  image_url2: string;
}

export function ProductCategoryModal({
  showModal,
  availableTypes = [],
  onDismiss,
  onConfirm,
}: Props) {

  const [productTypes, setProductTypes] = useState<IProductTypes[]>(
    [] as IProductTypes[],
  );

  const getProductTypes = useCallback(async () => {
    try {
      if (availableTypes.length === 0) return;
      const response = await api.post('/tipoProduto');
      if (response.data) {
        const availableCodeTypes = availableTypes.map(t => t.tipo_produto);
        setProductTypes(
          response.data.filter((t: any) =>
            availableCodeTypes.includes(t.codigo),
          ),
        );
      }
    } catch (err) {
      console.log(err);
    } 
  }, [availableTypes]);

  const getProducts = useCallback(
    async (codigo: string) => {
      try {
        const loja = availableTypes.find(t => t.tipo_produto === codigo);
        if (!loja) return;
        const response = await api.get(`/produtos_diversos_postos`, {
          params: {
            posto: loja.loja_id,
          },
        });
        if (response.data) {
          console.log(response.data)
          onConfirm(response.data.produtos, response.data.loja, codigo);
        }
      } catch (err) {
        console.log(err);
      } 
    },
    [availableTypes],
  );

  useEffect(() => {
    getProductTypes();
  }, [getProductTypes]);


  return (
    <Container
      isVisible={showModal}
      onBackButtonPress={onDismiss}
      onBackdropPress={onDismiss}>
      <ModalContent>
        <ModalBody>
          <CloseButton onPress={onDismiss} activeOpacity={0.7}>
            <CloseButtonIcon name="x" />
          </CloseButton>
          <ModalInfos>
            <ModalTitle>Mais produtos</ModalTitle>
            <ModalSubtitle>Aqui você também tem outras opções:</ModalSubtitle>
          </ModalInfos>
          {productTypes
            .sort((a, b) => a.ordem - b.ordem)
            .map(categoria => (
              <ProductCategoryItem
                key={categoria.codigo}
                activeOpacity={1}
                onPress={() => getProducts(categoria.codigo)}
                style={{
                  width: '100%',
                }}>
                <ProductMask />
                <ProductCategoryImage source={{uri: categoria.image_url2}} />
                <ProductCategoryInfos>
                  <ProductTypeName>{categoria.nome}</ProductTypeName>
                </ProductCategoryInfos>
              </ProductCategoryItem>
            ))}
        </ModalBody>
      </ModalContent>
    </Container>
  );
}
